import { useUIDSeed as e } from "react-uid";
const o = () => e()("error-id");
export {
  o as useErrorId
};
//# sourceMappingURL=useErrorId.js.map
